import { catchError, map, shareReplay } from 'rxjs/operators';
import { combineLatest, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { HubMediaState } from '@hub-store/media/media.reducer';

@Injectable({ providedIn: 'root' })
export class MediaService {
  path: string = '/api';
  constructor(private apiService: ApiService) { }

  getPhotos(partnerId: any) {
    return this.apiService.get<{ data: any[] }>(`${this.path}/v2/airlines/${partnerId}/photos`).pipe(map(media => media.data),catchError(() => of([])));
  }

  getPhoto(partnerId: any, photoId: any) {
    return this.apiService.get<{ data: any }>(`${this.path}/v2/airlines/${partnerId}/photos/${photoId}`).pipe(map(media => media.data),catchError(() => of({})));
  }

  getInfographics(partnerId: any) {
    return this.apiService.get<{ data: any[] }>(`${this.path}/v2/airlines/${partnerId}/infographics`).pipe(map(media => media.data),catchError(() => of([])));
  }

  getMarketingGraphics(partnerId: any) {
    return this.apiService.get<{ data: any[] }>(`${this.path}/v2/airlines/${partnerId}/marketing_graphics`).pipe(map(media => media.data),catchError(() => of([])));
  }

  getVideos(partnerId: any) {
    return this.apiService.get<{ data: any[] }>(`${this.path}/v2/airlines/${partnerId}/videos`).pipe(map(media => media.data),catchError(() => of([])));
  }

  getTours(partnerId: any) {
    return this.apiService.get<{ data: any[] }>(`${this.path}/v2/airlines/${partnerId}/tours`).pipe(map(media => media.data),catchError(() => of([])));
  }

  getCombinedMedia(partnerId: any): Observable<HubMediaState> {
    return combineLatest([
      this.getPhotos(partnerId),
      this.getVideos(partnerId),
      this.getTours(partnerId),
      this.getInfographics(partnerId),
      this.getMarketingGraphics(partnerId),
    ]).pipe(
      shareReplay(1),
      map((response: any) => {
        return {
          photos: response[0],
          videos: response[1],
          tours: response[2],
          infographics: response[3],
          marketing_graphics: response[4],
        }
      }),
    );
  }
}
